export const playgroundBaseUrl = "/play/"
export const home = "/"
